import React, { Component } from 'react'
import {
    Button, Container, Table, Form, Input, Row
} from 'reactstrap'
import Categoria from '../../utilitarios/productoCategoria'
import './productosCategoria.css'
const categoria = new Categoria

export default class AdminProductosCategoria extends Component {
    constructor(props) {
        super(props)

        this.state = {
            Descripcion: '',
            categorias: []
        }
        this.onChange = this.onChange.bind(this)
        this.leerCategorias = this.leerCategorias.bind(this)
        this.guardarCategoria = this.guardarCategoria.bind(this)
        this.eliminarCategoria = this.eliminarCategoria.bind(this)
    }

    onChange(e) {
        this.setState({
            Descripcion: e.target.value
        })
    }

    guardarCategoria(e) {
        e.preventDefault()
        const _this = this
        const cat = {
            Descripcion: this.state.Descripcion
        }
        categoria.guardar(cat).then(() => {
            _this.leerCategorias()
        })
    }

    eliminarCategoria(e) {
        const _this = this
        let eliminar = window.confirm(`¿Desea eliminar ésta categoría? \n ${e.target.name}`)
        if (eliminar) {
            categoria.eliminar(e.target.id).then(_this.leerCategorias())

        }
    }

    leerCategorias() {
        const _this = this
        categoria.getCategorias().then(categorias => {
            _this.setState({
                categorias,
                Descripcion: ''
            })
        })
    }

    componentWillMount() {
        this.leerCategorias()
    }

    render() {
        return (
            <Container>

                <Row>
                    <h2>Categorías de productos</h2>
                </Row>
                <Row>

                    <Button color="warning" onClick={this.props.atras}>Atrás</Button>
                </Row>

                <Row>
                    <Form className="formNuevaCategoria" onSubmit={this.guardarCategoria} inline>
                        <Input onChange={this.onChange} value={this.state.Descripcion} type="text" id="Descripcion" placeholder="Descripción" required /> {' '}
                        <Button color="success"> Guardar</Button>
                    </Form>
                </Row>

                <Row>
                    <Table hover>
                        <thead>
                            <tr>
                                <th>Descripción</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.categorias.map(cat => {
                                    return <tr key={cat.id}>
                                        <td>{cat.data().Descripcion}</td>
                                        <td><Button id={cat.id} name={cat.data().Descripcion} onClick={this.eliminarCategoria} color="danger" size="sm">Eliminar</Button></td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </Table>
                </Row>
            </Container>
        )
    }
}